module.exports = __webpack_public_path__ + "img/battery-mid.d18ee151.svg";